// TypeScript entry point wrapper for Create React App
require('./index.tsx');